export const adminToolsConstants = {
  ADMIN_TOOLS: 'Admin Tools',
};
